<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center" dense>
          <v-col cols="12" sm="12" md="8" lg="8" style="text-align: center;">
            <v-card class="login" flat style="border-radius: 10px; padding: 10px;" height="430px" color="#FCE4EC">
              <span class="login-title">
                <img src="../../assets/logoAIPassIntelite-preto.png" width="300px" style="margin-top: 10px">
              </span>
              <v-card-actions style="padding: 0px; margin-top: 0px;">
                <v-container fluid grid-list-md>
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12">
                      <div style="text-align: center;" class="names hide"></div>
                      <div class="winner">Preparados para o sorteio?</div>
                      <div class="winner hide"></div>
                      <v-btn x-large class="roll" style="border-radius: 7px;" dark depressed block color="#132651"
                        @click="rollClick">SORTEAR!</v-btn>
                      <v-btn x-large class="roll-again hide" style="border-radius: 7px;" dark depressed block
                        color="#132651" @click="rollClick">SORTEAR NOVAMENTE</v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="8" lg="8" style="text-align: center;">
            <v-card class="login" flat style="border-radius: 10px; padding: 0px 10px 0px 10px;" color="#FCE4EC">
              <v-card-actions style="padding: 0px; margin-top: 0px;">
                <v-container fluid grid-list-md>
                  <v-row>
                    <v-col cols="12">
                      <v-alert type="info" style="text-align: left; margin-bottom: 0px" v-if="winners.length == 0">As
                        ganhadores aparecerão aqui</v-alert>
                      <p style="text-align: left; font-size: 30px" class="winner" v-if="winners.length == 1">
                        Ganhador(a):
                      </p>
                      <p style="text-align: left; font-size: 30px" class="winner" v-if="winners.length > 1">Ganhadores:
                      </p>
                      <ol>
                        <li class="texto" style="text-align: left; font-size: 20px" v-for="winner in winners"
                          :key="winner">{{ winner }}</li>
                      </ol>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      eventoId: '',
      inscritos: [],
      ENTRANTS: ["Wlysses", "Rebeca", "Vinicius"],
      rollEl: '',
      rollAgainEl: '',
      namesEl: '',
      winnerEl: '',
      winners: [],
      empresa: [],
    }
  },

  computed: {
    ...mapState({
      usuarioadmin: state => state.Userpermission,
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),
  },

  mounted() {
    //this.carregaDados()
    this.rollEl = document.querySelector(".roll"),
      this.rollAgainEl = document.querySelector(".roll-again"),
      this.namesEl = document.querySelector(".names"),
      this.winnerEl = document.querySelector(".winner")
    this.carregaDados()
  },

  watch: {
    tipo(val) {
      if (val === '1') {
        this.cpf = ""
        this.$validator.reset()
      } else if (val === '2')
        this.codigo = ''
    }
  },

  methods: {
    async carregaDados() {
      let eventos = [
        "665e3eb74d4de4110ec9c385",
        "661ea0f135927c1c5d9723ac",
      ]
      let inscritos = []
      this.inscritos = []

      for (let i = 0; i < eventos.length; i++) {
        await axios.post(baseApiUrl + 'inscricoes/listaSorteio', { "eventoId": eventos[i] })
          .then(response => {
            if (response.data) {
              for (var key in response.data) {
                if (response.data.hasOwnProperty(key) && response.data[key]) {
                  inscritos.push(response.data[key])
                }
              }
            }
          })
      }

      this.inscritos = inscritos
    },

    randomName() {
      const rand = Math.floor(Math.random() * this.inscritos.length);
      const name = this.inscritos[rand];
      //const namesEl = document.querySelector(".names");
      this.namesEl.innerText = name;
    },

    rollClick() {
      this.rollEl.classList.add("hide");
      this.rollAgainEl.classList.add("hide");
      this.winnerEl.classList.add("hide");
      this.namesEl.classList.remove("hide");

      this.setDeceleratingTimeout(this.randomName, 10, 30);

      setTimeout(() => {
        this.namesEl.classList.add("hide");
        this.winnerEl.classList.remove("hide");
        this.rollAgainEl.classList.remove("hide");

        const winner = this.namesEl.innerText;
        this.winnerEl.innerText = winner;
        this.winners.push(winner)
        this.winnerEl.innerHTML = `<span>Ganhador(a):</span><br>${winner}`;
      }, 5000);
    },

    setDeceleratingTimeout(callback, factor, times) {
      const internalCallback = ((t, counter) => {
        return () => {
          if (--t > 0) {
            setTimeout(internalCallback, ++counter * factor);
            callback();
          }
        };
      })(times, 0);

      setTimeout(internalCallback, factor);
    },
  }
}
</script>

<style scoped>
.hide {
  display: none
}

body {
  color: #fff;
  background-color: #253241;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: 900;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.roll-again {
  cursor: pointer;
  appearance: none;
  background-color: transparent;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: 700;
  padding: 0;
  margin-top: 2em;
  color: white;
  border: none;
  opacity: .5;
  transition: 200ms ease-in-out;
  opacity: 1;
}

.roll {
  cursor: pointer;
  appearance: none;
  background-color: transparent;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: 700;
  padding: 0;
  margin-top: 2em;
  color: white;
  border: none;
  opacity: .5;
  transition: 200ms ease-in-out;
  opacity: 1;
}

.names {
  font-size: 3.2rem
}

.winner {
  font-size: 3.2rem;
  text-align: center;
}

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;
  background: linear-gradient(to right, #132651, #1c439e);
  background-repeat: no-repeat;
  position: relative;
  z-index: 1;
}

.texto {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

.login {
  min-width: 80%;
  border-radius: 15px;
  background-color: #fff;
  opacity: 0.9;
  padding-top: 15px;
  padding-bottom: 15px;
}

.login-title {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center
}

a {
  text-decoration: none
}
</style>